import {Component, HostListener, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {TranslateService} from '@ngx-translate/core';
import {LangChange} from '../../../../../lang-change';
import {Utils} from '../../../../../common/services/Utils';
import {Principal} from '../../../../../common/services/principal';
import {Language} from '../../../../../common/models/language';
import {RestorePassword} from '../restore-password';
import {CommonService} from '../../../../shared/services/common.service';
import {RestorePasswordService} from '../../../services/restore-password.service';
import {Response} from '../../../../../common/dtos/response';

@Component({
  selector: 'app-restore-password-modal',
  templateUrl: './restore-password-modal.component.html',
  styleUrls: ['./restore-password-modal.component.scss']
})
export class RestorePasswordModalComponent extends LangChange implements OnInit {

  langId: number;
  restorePass: RestorePassword;
  captchaData = null;
  isCaptchaValid = false;

  constructor(public dialogRef: MatDialogRef<RestorePasswordModalComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private utils: Utils,
              private principal: Principal,
              private commonService: CommonService,
              private restorePasswordService: RestorePasswordService,
              private translateService: TranslateService) {
    super(translateService);
  }

  ngOnInit() {
    this.restorePass = new RestorePassword();
    console.log(this.data);
    // this.restorePass.psType = this.data.psType;
    this.langId = Language.getCurrentLanguage().id;
    this.reloadCaptcha();
  }

  reloadCaptcha() {
    this.commonService.getCaptcha().subscribe(data => {
      this.captchaData = data;
    });
  }

  validateCaptcha(val) {
    if (val && val.length > 2) {
      this.commonService.validateCaptcha(this.captchaData.captchaId, val).subscribe(data => {
        if (data && data.success) {
          this.isCaptchaValid = true;
        }
      });
    }
  }

  @HostListener('keydown.esc')
  public onEsc() {
    this.dialogRef.close();
  }

  onLangChange(langCode): void {
    this.langId = langCode.id;
    this.changeLang();
  }

  changeLang() {
  }

  onSubmit() {
    this.utils.blockStart(null);
    this.restorePasswordService.restorePassword(this.restorePass.email).subscribe(
      (res: Response) => {
        if (res.status === 'SUCCESS') {
          this.utils.notifySuccess(this.translateService.instant('restore_password.msg_sent_success'), null);
          this.dialogRef.close();
        } else if (res.description) {
          this.utils.notifyError(this.translateService.instant('restore_password.' + res.description), null);
        }
        this.utils.blockStop();
      },
      error => {
        this.utils.notifyError(this.translateService.instant('err_try_again_later'), null);
        this.utils.blockStop();
      }
    );
  }

  close(): void {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/common-main/components/restore-password/modal/restore-password-modal.component.ts